export var returnWrapper = function (awaitable) { return ({
    promise: awaitable || Promise.resolve(),
}); };
//# sourceMappingURL=return-wrapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amplitude/analytics-core/lib/esm/utils/return-wrapper.js
// module id = 334
// module chunks = 1